__turbopack_context__.v({
  "embla": "PYFnmG_embla",
  "emblaContainer": "PYFnmG_emblaContainer",
  "emblaSlide": "PYFnmG_emblaSlide",
  "footerItemContent": "PYFnmG_footerItemContent",
  "imageContainer": "PYFnmG_imageContainer",
  "plus": "PYFnmG_plus",
  "root": "PYFnmG_root",
  "square": "PYFnmG_square",
});
